import React, { useState, useEffect } from 'react';

const WhatsAppFloat = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isPulsing, setIsPulsing] = useState(false);
  
  // Pulse animation effect
  useEffect(() => {
    const interval = setInterval(() => {
      setIsPulsing(prev => !prev);
    }, 2000);
    return () => clearInterval(interval);
  }, []);
  
  // Replace with your actual WhatsApp number (without + or spaces)
  const phoneNumber = '919151739999';
  const message = 'Hi! I would like to know more about Nakshatra Infra projects.';
  
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <div style={{
      position: 'fixed',
      right: '20px',
      bottom: '20px',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      gap: '15px'
    }}>
      {/* Message Tooltip */}
      <div style={{
        background: 'white',
        padding: '12px 20px',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        opacity: isHovered ? 1 : 0,
        transform: isHovered ? 'translateX(0)' : 'translateX(-20px)',
        transition: 'all 0.3s ease',
        pointerEvents: isHovered ? 'auto' : 'none',
        maxWidth: '250px'
      }}>
        <div style={{
          color: '#333',
          fontWeight: 600,
          fontSize: '0.95rem',
          marginBottom: '4px'
        }}>
          Need Help?
        </div>
        <div style={{
          color: '#666',
          fontSize: '0.85rem',
          lineHeight: '1.4'
        }}>
          Chat with us on WhatsApp!
        </div>
        {/* Arrow pointing to button */}
        <div style={{
          position: 'absolute',
          right: '-8px',
          top: '50%',
          transform: 'translateY(-50%)',
          width: 0,
          height: 0,
          borderTop: '8px solid transparent',
          borderBottom: '8px solid transparent',
          borderLeft: '8px solid white',
          filter: 'drop-shadow(2px 0 3px rgba(0,0,0,0.1))'
        }} />
      </div>

      {/* WhatsApp Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: isHovered 
            ? '0 8px 30px rgba(37, 211, 102, 0.5)' 
            : isPulsing 
              ? '0 4px 30px rgba(37, 211, 102, 0.6)' 
              : '0 4px 20px rgba(37, 211, 102, 0.4)',
          cursor: 'pointer',
          textDecoration: 'none',
          transition: 'all 0.3s ease',
          transform: isHovered ? 'scale(1.1)' : 'scale(1)'
        }}
      >
        {/* WhatsApp Icon SVG */}
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 0C7.164 0 0 7.164 0 16c0 2.825.745 5.606 2.155 8.039L.058 31.943l8.062-2.111A15.937 15.937 0 0 0 16 32c8.836 0 16-7.164 16-16S24.836 0 16 0z"
            fill="#fff"
          />
          <path
            d="M25.376 22.717c-.364 1.028-2.148 1.907-3.023 2.028-.756.098-1.738.139-2.81-.176-.65-.191-1.485-.445-2.551-.874-4.463-1.793-7.369-6.293-7.59-6.583-.221-.29-1.801-2.396-1.801-4.572 0-2.176 1.139-3.245 1.543-3.686.404-.441.883-.551 1.178-.551.295 0 .59.003.848.014.271.012.636-.103.996.759.364.872 1.246 3.048 1.354 3.269.109.221.182.478.036.769-.145.29-.218.472-.436.726-.217.255-.457.57-.653.765-.218.217-.444.45-.191.884.254.434 1.128 1.86 2.42 3.013 1.664 1.484 3.066 1.945 3.499 2.166.434.221.687.184.94-.11.254-.295.578-.769.906-1.243.236-.341.532-.384.895-.221.364.163 2.312 1.09 2.709 1.289.397.199.662.295.758.46.096.164.096 1.192-.268 2.22z"
            fill="#25D366"
          />
        </svg>
      </a>
    </div>
  );
};

export default WhatsAppFloat;